const getBasePath = (pathname = '') => {
  let path

  path = pathname.match(
    /^(\/[a-z-]+\/)\/*?[a-z-]+\/[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/,
  )

  if (!path) {
    path = pathname.match(
      /^(\/[a-z-]+\/)\/*?[a-z-]+\/[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}\/[a-zA-Z]+$/,
    )
  }

  if (!path) {
    path = pathname.match(
      /^(\/[a-z-]+\/)\/*?[a-z-]+\/[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}\/[a-zA-Z]+\/[a-zA-Z]+$/,
    )
  }

  if (!path) {
    path = pathname.match(/(\/[a-z-]+\/[a-z-]+)\/.+/)
  }

  if (!path) {
    path = pathname.match(/(\/[a-z-]+)\/[a-z-]+/)
  }

  if (!path) {
    return ''
  }

  return path[1].split('/').length <= 1 ? path[0] : path[1]
}

export default getBasePath
